/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  CcofCaptureConfirmRequest,
  CcofCaptureInitiateResponse,
  CcofCaptureLinkInitiateResponse,
  CcofCaptureLinkRequest,
  CcofCaptureMisassignResponse,
  CcofCaptureStaffRequest,
  CcofCardOnFile,
  ProblemDetails,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

/**
 * **Actor types:** `clinic`, `internal`

**Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims

Creates a capture session (Kind=PatientLink), generates a secure opaque token, and dispatches an SMS. Does not return ClientSecret — the patient resolves that via the token endpoint (CPAY-1723).
 * @summary Creates a patient self-service capture link and sends an SMS to the patient.
 */
export type postApiCcofPracticeIdCaptureInitiateResponse200 = {
  data: CcofCaptureLinkInitiateResponse;
  status: 200;
};

export type postApiCcofPracticeIdCaptureInitiateResponse400 = {
  data: ProblemDetails;
  status: 400;
};

export type postApiCcofPracticeIdCaptureInitiateResponse401 = {
  data: ProblemDetails;
  status: 401;
};

export type postApiCcofPracticeIdCaptureInitiateResponse403 = {
  data: void;
  status: 403;
};

export type postApiCcofPracticeIdCaptureInitiateResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postApiCcofPracticeIdCaptureInitiateResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postApiCcofPracticeIdCaptureInitiateResponse422 = {
  data: ProblemDetails;
  status: 422;
};

export type postApiCcofPracticeIdCaptureInitiateResponseSuccess =
  postApiCcofPracticeIdCaptureInitiateResponse200 & {
    headers: Headers;
  };
export type postApiCcofPracticeIdCaptureInitiateResponseError = (
  | postApiCcofPracticeIdCaptureInitiateResponse400
  | postApiCcofPracticeIdCaptureInitiateResponse401
  | postApiCcofPracticeIdCaptureInitiateResponse403
  | postApiCcofPracticeIdCaptureInitiateResponse404
  | postApiCcofPracticeIdCaptureInitiateResponse409
  | postApiCcofPracticeIdCaptureInitiateResponse422
) & {
  headers: Headers;
};

export const getPostApiCcofPracticeIdCaptureInitiateUrl = (
  practiceId: string,
) => {
  return `/api/ccof/${practiceId}/capture/initiate`;
};

export const postApiCcofPracticeIdCaptureInitiate = async (
  practiceId: string,
  ccofCaptureLinkRequest: CcofCaptureLinkRequest,
  options?: RequestInit,
): Promise<postApiCcofPracticeIdCaptureInitiateResponseSuccess> => {
  return authenticatedClient<postApiCcofPracticeIdCaptureInitiateResponseSuccess>(
    getPostApiCcofPracticeIdCaptureInitiateUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(ccofCaptureLinkRequest),
    },
  );
};

/**
 * **Actor types:** `clinic`, `internal`

**Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims

Transitions the session to misassigned, deactivates the specific card saved by this session, and best-effort detaches the PaymentMethod from Stripe. Returns { cardDetached }.
 * @summary Marks a completed capture session as misassigned (wrong patient or guarantor).
 */
export type postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse200 = {
  data: CcofCaptureMisassignResponse;
  status: 200;
};

export type postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse401 = {
  data: ProblemDetails;
  status: 401;
};

export type postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse403 = {
  data: void;
  status: 403;
};

export type postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponseSuccess =
  postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse200 & {
    headers: Headers;
  };
export type postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponseError =
  (
    | postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse401
    | postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse403
    | postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse404
    | postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponse409
  ) & {
    headers: Headers;
  };

export const getPostApiCcofPracticeIdCaptureCaptureSessionIdMisassignUrl = (
  practiceId: string,
  captureSessionId: string,
) => {
  return `/api/ccof/${practiceId}/capture/${captureSessionId}/misassign`;
};

export const postApiCcofPracticeIdCaptureCaptureSessionIdMisassign = async (
  practiceId: string,
  captureSessionId: string,
  options?: RequestInit,
): Promise<postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponseSuccess> => {
  return authenticatedClient<postApiCcofPracticeIdCaptureCaptureSessionIdMisassignResponseSuccess>(
    getPostApiCcofPracticeIdCaptureCaptureSessionIdMisassignUrl(
      practiceId,
      captureSessionId,
    ),
    {
      ...options,
      method: "POST",
    },
  );
};

/**
 * **Actor types:** `clinic`, `internal`

**Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims

Creates a Stripe SetupIntent on the practice's connected account and returns its client_secret for the FE to mount a Stripe Elements PaymentElement. No card data touches this backend.
 * @summary Initiates a staff-assisted card-on-file capture for a patient, scoped to the active practice.
 */
export type postApiCcofPracticeIdCaptureStaffResponse200 = {
  data: CcofCaptureInitiateResponse;
  status: 200;
};

export type postApiCcofPracticeIdCaptureStaffResponse400 = {
  data: ProblemDetails;
  status: 400;
};

export type postApiCcofPracticeIdCaptureStaffResponse401 = {
  data: ProblemDetails;
  status: 401;
};

export type postApiCcofPracticeIdCaptureStaffResponse403 = {
  data: void;
  status: 403;
};

export type postApiCcofPracticeIdCaptureStaffResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postApiCcofPracticeIdCaptureStaffResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postApiCcofPracticeIdCaptureStaffResponse500 = {
  data: void;
  status: 500;
};

export type postApiCcofPracticeIdCaptureStaffResponseSuccess =
  postApiCcofPracticeIdCaptureStaffResponse200 & {
    headers: Headers;
  };
export type postApiCcofPracticeIdCaptureStaffResponseError = (
  | postApiCcofPracticeIdCaptureStaffResponse400
  | postApiCcofPracticeIdCaptureStaffResponse401
  | postApiCcofPracticeIdCaptureStaffResponse403
  | postApiCcofPracticeIdCaptureStaffResponse404
  | postApiCcofPracticeIdCaptureStaffResponse409
  | postApiCcofPracticeIdCaptureStaffResponse500
) & {
  headers: Headers;
};

export const getPostApiCcofPracticeIdCaptureStaffUrl = (practiceId: string) => {
  return `/api/ccof/${practiceId}/capture/staff`;
};

export const postApiCcofPracticeIdCaptureStaff = async (
  practiceId: string,
  ccofCaptureStaffRequest: CcofCaptureStaffRequest,
  options?: RequestInit,
): Promise<postApiCcofPracticeIdCaptureStaffResponseSuccess> => {
  return authenticatedClient<postApiCcofPracticeIdCaptureStaffResponseSuccess>(
    getPostApiCcofPracticeIdCaptureStaffUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(ccofCaptureStaffRequest),
    },
  );
};

/**
 * **Actor types:** `clinic`, `internal`

**Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims

Identifies the capture by the SetupIntent id retained on the redirected page. Reads the SetupIntent + card details directly from the Stripe API (not via webhook) so the staff UI renders the saved card immediately. On 202 (not yet settled) or 502 (Stripe unreachable) the FE falls back to polling patient details. The webhook remains the async source of truth.
 * @summary Synchronously confirms a staff-assisted card capture straight after the Stripe redirect (CPAY-2018).
 */
export type postApiCcofPracticeIdCaptureConfirmResponse200 = {
  data: CcofCardOnFile;
  status: 200;
};

export type postApiCcofPracticeIdCaptureConfirmResponse202 = {
  data: void;
  status: 202;
};

export type postApiCcofPracticeIdCaptureConfirmResponse401 = {
  data: ProblemDetails;
  status: 401;
};

export type postApiCcofPracticeIdCaptureConfirmResponse403 = {
  data: void;
  status: 403;
};

export type postApiCcofPracticeIdCaptureConfirmResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postApiCcofPracticeIdCaptureConfirmResponse502 = {
  data: void;
  status: 502;
};

export type postApiCcofPracticeIdCaptureConfirmResponseSuccess = (
  | postApiCcofPracticeIdCaptureConfirmResponse200
  | postApiCcofPracticeIdCaptureConfirmResponse202
) & {
  headers: Headers;
};
export type postApiCcofPracticeIdCaptureConfirmResponseError = (
  | postApiCcofPracticeIdCaptureConfirmResponse401
  | postApiCcofPracticeIdCaptureConfirmResponse403
  | postApiCcofPracticeIdCaptureConfirmResponse404
  | postApiCcofPracticeIdCaptureConfirmResponse502
) & {
  headers: Headers;
};

export const getPostApiCcofPracticeIdCaptureConfirmUrl = (
  practiceId: string,
) => {
  return `/api/ccof/${practiceId}/capture/confirm`;
};

export const postApiCcofPracticeIdCaptureConfirm = async (
  practiceId: string,
  ccofCaptureConfirmRequest: CcofCaptureConfirmRequest,
  options?: RequestInit,
): Promise<postApiCcofPracticeIdCaptureConfirmResponseSuccess> => {
  return authenticatedClient<postApiCcofPracticeIdCaptureConfirmResponseSuccess>(
    getPostApiCcofPracticeIdCaptureConfirmUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(ccofCaptureConfirmRequest),
    },
  );
};
